import { render } from "./VerificationForm.vue?vue&type=template&id=e4471a1c&scoped=true"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"

import "./VerificationForm.vue?vue&type=style&index=0&id=e4471a1c&scoped=true&lang=css"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4471a1c"]])

export default __exports__